"use client";
import { jsx as c } from "react/jsx-runtime";
import { mergeAndCompare as g } from "merge-anything";
import { createContext as m, useContext as h } from "react";
import { defaultInkeepSearchSettings as p, defaultInkeepBaseSettings as C, defaultInkeepAIChatSettings as f } from "../utils/default-settings.js";
import { useShadow as u } from "../atoms/shadow/context.js";
const S = {
  ChatButton: "ChatButton",
  CustomTrigger: "CustomTrigger",
  SearchBar: "SearchBar",
  EmbeddedChat: "EmbeddedChat",
  EmbeddedSearch: "EmbeddedSearch",
  EmbeddedSearchAndChat: "EmbeddedSearchAndChat",
  IntelligentForm: "IntelligentForm"
}, r = {
  prefix: "ikp",
  // Default prefix
  aiChatSettings: f,
  baseSettings: C,
  searchSettings: p,
  componentType: S.EmbeddedChat
}, i = m(r), A = ({ children: e, value: n }) => {
  const s = u(), a = g((d, t, o) => (o === "apiKey" && !t && !n?.baseSettings?.aiApiBaseUrl && console.warn("Inkeep API key is missing."), ["baseSettings", "searchSettings", "aiChatSettings"].includes(o) && !t ? d : t), r, {
    baseSettings: s ?? {}
  }, n ?? {});
  return /* @__PURE__ */ c(i.Provider, { value: a, children: e });
}, B = () => {
  const e = h(i);
  if (!e)
    throw new Error("useInkeepConfig must be used within a ConfigProvider");
  return e;
};
export {
  A as InkeepConfigProvider,
  S as WebWidgetInteractionType,
  B as useInkeepConfig
};
